import React from 'react';
import classNames from 'classnames';
import './GridStyles.scss';
import { Icons } from '../BootstrapComponents';

export default function Grid(props) {
  const {
    columns,
    data,
    className,
    selectedRow = null,
    hideHeader = false,
    loading = false,
    isSelected = () => {},
    emptyText = 'Нет данных',
    onClickByRow = () => {},
    rowClassFormatter = () => {},
    sort = [],
    changeSort = () => {},
  } = props;

  const onSelectRow = (item, index) => event => {
    onClickByRow(item, event, index);
  };

  const renderHeaderCell = (item, key) => {
    const { headerStyle = {}, headerClassName } = item;
    let content = item.text;
    if (item.headerFormatter && typeof item.headerFormatter === 'function') {
      content = item.headerFormatter(content, item);
    }
    const sortName = item.sortField || item.dataField;
    const el = sort.find(i => i === sortName || i === `-${sortName}`);
    return (
      <th
        key={key}
        style={headerStyle}
        className={classNames('table-header-cell', `column-${key}`, headerClassName, { 'sorted-column': !item.disableSort }, { 'revert-sort': el && el[0] === '-' })}
        role="columnheader"
        scope="col"
        onClick={!item.disableSort ? changeSort(sortName) : () => {}}
      >
        <div className="table-column-wrapper">
          <span className={classNames('table-column')}>
            {content}
          </span>
          <span className="table-column-sorted">
            {!item.disableSort && el ? <Icons customIcon icon="arrow-drop-down" /> : null}
          </span>
        </div>
      </th>
    );
  };

  const renderCell = (row, item, key, rowKey) => {
    let content = row[item.dataField];
    const { bodyStyle = {}, dataClassName = '' } = item;
    if (item.formatter && typeof item.formatter === 'function') {
      content = item.formatter(content, row, rowKey);
    }
    return (
      <td
        key={key}
        style={bodyStyle}
        className={classNames('data-table-cell', dataClassName)}
      >
        {content}
      </td>
    );
  };

  return (
    <table className={classNames('table', className, { empty: !data || data.length < 1 })}>
      {!hideHeader
        ? (
          <thead className="data-table-header">
            <tr className="table-header-row">
              {columns.map(renderHeaderCell)}
            </tr>
          </thead>
        )
        : null}
      <tbody className="data-table-content">
        {data && data.map((row, rowKey) => (
          <tr
            key={rowKey}
            className={classNames('data-table-row', { selected: isSelected(selectedRow, row, rowKey) }, rowClassFormatter(row))}
            onClick={onSelectRow(row, rowKey)}
          >
            {columns.map((item, key) => (renderCell(row, item, key, rowKey)))}
          </tr>
        ))}
        {(!data || data.length < 1) && emptyText && !loading ? (<tr><td colSpan={columns.length || 0} className="text-center align-middle">{emptyText}</td></tr>) : null}
        {(!data || data.length < 1) && loading ? (<tr><td colSpan={columns.length || 0} className="text-center align-middle">Идет загрузка</td></tr>) : null}
      </tbody>
    </table>
  );
}
